import { Suspense, lazy } from 'react';

import { KDErrorBoundary } from '@/components';
import { KDLayoutDashboardLoader } from '@/layouts';

const MerksFormPage = lazy(() => import('./MerksForm.page'));

export const MerksForm = () => {
  return (
    <KDErrorBoundary>
      <Suspense fallback={<KDLayoutDashboardLoader />}>
        <MerksFormPage />
      </Suspense>
    </KDErrorBoundary>
  );
};
